import React from 'react';
import { connect } from 'react-redux';

import { CountryDto } from '@src/meta/types/billing/vat';
import { ThunkDispatch } from '@src/meta/types/actions';
import { getCountries } from '@src/actions/billing';
import { StoreState } from '@src/meta/types/store';
import { CountryListType } from '@src/constants/countries';

import CountryPicker from './CountryPicker';

type PropsFromState = {
  fetchingCountries: boolean;
  countries: Record<CountryListType, CountryDto[]>;
};

type PropsFromDispatch = {
  getCountries: (listType: CountryListType) => () => Promise<void>;
};

type Props = PropsFromState &
  PropsFromDispatch & {
    setCountry: (country: string) => void;
    country?: string;
    error?: boolean;
    label?: string;
    useIp: boolean;
    type: CountryListType;
  };

const ConnectedCountryPicker = ({
  getCountries,
  fetchingCountries,
  countries,
  country,
  setCountry,
  label,
  error,
  useIp,
  type,
}: Props) => {
  return (
    <CountryPicker
      label={label}
      useIp={useIp}
      country={country}
      setCountry={setCountry}
      getCountries={getCountries(type)}
      fetchingCountries={fetchingCountries}
      countries={countries[type] || []}
      error={error}
    />
  );
};

const mapDispatchToProps = (dispatch: ThunkDispatch): PropsFromDispatch => {
  return {
    getCountries: (listType: CountryListType) => () => dispatch(getCountries(listType)),
  };
};

function mapStateToProps(state: StoreState): PropsFromState {
  return {
    fetchingCountries: state.billing.fetchingCountries,
    countries: state.billing.countries,
  };
}

const enhance = connect(mapStateToProps, mapDispatchToProps);

export default enhance(ConnectedCountryPicker);
